import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'

export const Wrapper = styled(Flex)`
  height: 70vh;
  align-items: center;
  justify-content: center;
`
export const Content = styled.div`
  text-align: center;
`
export const CheckIconLayerOne = styled(Flex)`
  width: 1.7rem;
  height: 1.7rem;
  background-color: ${COLORS.GREEN_S_100};
  border-radius: 50%;
  margin: auto;
  align-items: center;
  justify-content: center;
`
export const CheckIconLayerTwo = styled(Flex)`
  width: 3rem;
  height: 3rem;
  background-color: ${COLORS.GREEN_T_90};
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  margin: auto;
`
export const BoldText = styled.div`
  font-weight: 600;
  line-height: 1.2rem;
`
export const BoldMuteText = styled.span`
  font-weight: 600;
  line-height: 1.2rem;
  color: ${COLORS.GREY_T_60};
`
export const MuteText = styled.span`
  font-weight: 400;
  line-height: 1.2rem;
  color: ${COLORS.GREY_T_60};
`
